import { VStack, Box } from "@chakra-ui/react";
import { useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import FooterPmsSearch from "../../navigation/footer/FooterPmsSearch";
import SearchFormHeader from "../../practitioner-search/SearchFormHeader";

import {
  incrementPmsSearchStep,
  decrementPmsSearchStep,
} from "../../redux/actions/layout";
import { updatePmsSearchDetails } from "../../redux/actions/pmsSearch";

import Lozenge from "../../components/common/Lozenge";
import TextInput from "../../components/forms/TextInput";
import TextAreaInput from "../../components/forms/TextAreaInput";
import PMSNavButtons from "./PMSNavButtons";
import SelectInput from "../../components/forms/SelectInput";

const PmsSearchMedicalForm = (props) => {
  const pmsSearch = useSelector((state) => state.pmsSearch);
  const dispatch = useDispatch();
  const formMedical = useRef();

  //set local state for lozenge selection
  const [healthInsurers, setHealthInsurers] = useState([]);
  const { healthInsurers: allHealthInsurers } = props.utilData;
  const [referred, setReferred] = useState([
    {
      value: "1",
      label: "No",
      selected: true,
    },
    {
      value: "2",
      label: "Yes",
      selected: false,
    },
  ]);
  const [referredForThis, setReferredForThis] = useState([
    {
      value: "1",
      label: "No",
      selected: true,
    },
    {
      value: "2",
      label: "Yes",
      selected: false,
    },
  ]);
  const [medication, setMedication] = useState("");
  const [previousExperience, setPreviousExperience] = useState(
    pmsSearch.previousExperience || ""
  );
  const [direction, setDirection] = useState(null);

  //integrate form with redux
  const [hasLoaded, setHasLoaded] = useState(false);
  useEffect(() => {
    if (pmsSearch.medication?.length > 0) setMedication(pmsSearch.medication);
    if (pmsSearch.previousExperience?.length > 0)
      setPreviousExperience(pmsSearch.previousExperience);
    if (pmsSearch.referred?.length > 0) setReferred(pmsSearch.referred);
    if (pmsSearch.referredForThis?.length > 0)
      setReferredForThis(pmsSearch.referredForThis);
    pmsSearch.healthInsurers?.length > 0
      ? setHealthInsurers(pmsSearch.healthInsurers)
      : setHealthInsurers(allHealthInsurers);

    setHasLoaded(true);
  }, [allHealthInsurers, pmsSearch]);

  // Render helpers
  const updateSelectedValue = (val, arr, setArr) => {
    let arrNew = arr.map((elem) =>
      Number(elem.value) === Number(val)
        ? { ...elem, selected: true }
        : { ...elem, selected: false }
    );
    setArr(arrNew);
  };

  // Footer navigation
  const handleClickPrev = () => {
    // Update state by forcing form submit
    setDirection("prev");
    formMedical.current.handleSubmit();
  };

  const handleClickNext = () => {
    setDirection("next");
    formMedical.current.handleSubmit();
  };

  // Wait for state to load
  if (!hasLoaded) return null;

  // Render
  return (
    <Formik
      innerRef={formMedical}
      initialValues={{ healthInsurers: healthInsurers }}
      validationSchema={Yup.object({})}
      onSubmit={(values) => {
        values.medication = medication;
        values.previousExperience = previousExperience;
        values.referred = referred;
        values.referredForThis = referredForThis;
        values.healthInsurers = healthInsurers;
        dispatch(updatePmsSearchDetails(values));
        direction === "next"
          ? dispatch(incrementPmsSearchStep())
          : dispatch(decrementPmsSearchStep());
      }}
    >
      {(formik) => (
        <>
          <Box width="100%" maxW="container.sm" mx="auto" mb="120px" pt="24px">
            <SearchFormHeader />
            <VStack
              as="form"
              maxW="full"
              py={7}
              px={5}
              //mx="auto"
              spacing={8}
              alignItems="flex-start"
              bg="white"
              borderRadius={{ base: 0, md: 20 }}
              onSubmit={formik.handleSubmit}
              boxShadow="lg"
              overflow="hidden"
            >
              <SelectInput
                name="healthInsurers"
                formlabel="Would you like to pay for your sessions using a specific health insurer?"
                variant="filled"
                placeholder="No"
                value={
                  healthInsurers
                    .filter((insurer) => insurer.selected)
                    .map((elem) => elem.value)[0]
                }
                onChange={(e) =>
                  updateSelectedValue(
                    e.target.value,
                    healthInsurers,
                    setHealthInsurers
                  )
                }
                required={true}
              >
                {healthInsurers.map((item, idx) => (
                  <option value={item.value} key={idx}>
                    {item.label}
                  </option>
                ))}
              </SelectInput>
              <TextInput
                name="medication"
                formlabel="Are you currently taking medication?"
                type="text"
                placeholder="If so, please note it here."
              />
              <Lozenge
                title="Have you been to therapy before for this or another issue?"
                data={referredForThis}
                onclick={setReferredForThis}
                required={true}
              />
              <TextAreaInput
                bg="brand.100"
                width="100%"
                name="previousExperience"
                formlabel="If yes, how did you find the sessions?"
                height="100px"
                value={previousExperience}
                onChange={(e) => setPreviousExperience(e.target.value)}
                placeholder="Please note any experience here."
              />
              <PMSNavButtons
                handleClickNext={handleClickNext}
                handleClickPrev={handleClickPrev}
              />
              <FooterPmsSearch
                handleClickNext={handleClickNext}
                handleClickPrev={handleClickPrev}
              />
            </VStack>
          </Box>
          {/* Footer */}
        </>
      )}
    </Formik>
  );
};

export default PmsSearchMedicalForm;
